import React,{useEffect,useState,useContext, memo} from 'react'
import axios from 'axios'
import { ManagerAuthContext } from "../context/AuthManager";
import { ToastContainer, toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import moment from "jalali-moment";

export const OldFolder = () => {

    const { currentUserRF } = useContext(ManagerAuthContext);

    const [search,setSearch] = useState('')
    const [searchT,setSearchT] = useState('')
    const [searchName,setSearchName] = useState('')
    const [mainList, setMainList] = useState([]);
    
const getAllProductsRT = async () => {
        const res = await fetch(`https://clinic.salamatpayanew.ir/Register/sicknesSperiodListR/${currentUserRF.nezam}&${search}`);
        setMainList(await res.json());
};

const getAllProductsTEL = async () => {
    const res = await fetch(`https://clinic.salamatpayanew.ir/Register/sicknesSperiodListTELR/${currentUserRF.nezam}&${searchT.replace("/","-").replace("/","-")}`);
    setMainList(await res.json());
};
const getAllProductsName = async () => {
    const res = await fetch(`https://clinic.salamatpayanew.ir/Register/sicknesSperiodListNameR/${currentUserRF.nezam}&${searchName}`);
    setMainList(await res.json());
};

    
const [showb, setShowb] = useState(false);
const handleCloseb = () => setShowb(false);
const handleShowb = () => setShowb(true);


const [descsR,setDescsR] = useState('')
const [meliR,setMeliR] = useState('')

const hendelShowFolder = async(id,ide) =>{
    setDescsR(id)
    setMeliR(ide)
    handleShowb(true)
}


const registerAll = async () => {
/*     if (!search) {
        toast.warning("لطفاً کد ملی را وارد کنید");
        return;
    } */

    try {
        const response = await axios.post('https://clinic.salamatpayanew.ir/registerOldfoder', {
            meli: meliR, // مقدار کد ملی از state
            descs: descsR,
            nezam: currentUserRF.nezam,
        });

        if (response.status === 200) {
            toast.success('اطلاعات با موفقیت ثبت شد');
            handleCloseb(); // بستن مدال
        } else {
            toast.error(`خطا: ${response.data.message || 'مشکلی پیش آمده است'}`);
        }
    } catch (error) {
        console.error('Error during registerAll:', error);
        if (error.response) {
            // اگر پاسخ خطایی از سرور دریافت شده باشد
            toast.error(`خطا: ${error.response.data.message || 'مشکلی پیش آمده است'}`);
        } else {
            // اگر خطا مربوط به ارتباط باشد
            toast.error('مشکلی در ارسال اطلاعات به سرور وجود دارد');
        }
    }
};



if (currentUserRF.meli === null) {
    toast.warning("Error Session Erp")
} else {

    return (
 <>
 <section class="m-0 content" dir='rtl'>
        <div class="row">
            <div class="d-flex flex-column flex-md-row justify-content-between">
            
                        <div class="custom-form-control form-group position-relative w-60">
                        <input type="text" maxLength={11} class="form-control" placeholder='کد ملی' onChange={(e) => setSearch(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-60 ms-2">
                        <button className='btn btn-info mt-4' onClick={getAllProductsRT}>کد ملی</button>
                        </div>
                        <div class="custom-form-control form-group position-relative w-60">
                        <input type="text"  class="form-control" placeholder='جستجو تاریخ تولد' onChange={(e) => setSearchT(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-60 ms-2">
                        <button className='btn btn-primary mt-4' onClick={getAllProductsTEL}>تاریخ تولد</button>
                        </div>      
                        <div class="custom-form-control form-group position-relative w-60">
                        <input type="text"  class="form-control" placeholder='نام و نام خانوادگی' onChange={(e) => setSearchName(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-60 ms-2">
                        <button className='btn btn-warning mt-4' onClick={getAllProductsName}>جستجو نام</button>
                        </div> 
                    </div>
                <div class="table-responsive">
                    <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                                <th><span>ردیف</span></th>
                                <th><span>نام بیمار</span></th>
                                <th><span>کد ملی</span></th>
                                <th><span>تاریخ تولد</span></th>
                                <th><span>ارجاع</span></th>
                            </tr>
                        </thead>

                        {mainList
                .map((item, index) => {
                    const { id, descs,meli } = item;
                  return (
                    <tbody
                      class="table-group-divider table-divider-color"
                      key={item.id}
                    >
                            <tr>
                                <td>{index+1}</td>
                                 <td>{item.name}</td>
                                <td>{item.meli}</td>
                                <td>{item.date}</td>
                      <td><button className='btn btn-primary' onClick={() => hendelShowFolder(descs,meli)} >مشاهده پرونده</button></td>
                     </tr>
                        </tbody>
                    );
                })}
                    </table>
                       
                </div>
            </div>
        </section>

 <Modal show={showb} onHide={handleCloseb} size='lg'>

                <textarea rows={10} value={descsR} className='form-control h-100' dir='ltr'></textarea>

        <button className='btn btn-primary' onClick={registerAll}>ارجاع-تایید</button>
      </Modal>

<ToastContainer
        position="top-left"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

   </>
  )
  }
}

